var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColumnUnactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.75L19.5 9.75C19.9142 9.75 20.25 9.41421 20.25 9L20.25 5.25C20.25 4.83579 19.9142 4.5 19.5 4.5L4.5 4.5C4.08579 4.5 3.75 4.83579 3.75 5.25L3.75 9C3.75 9.41421 4.08579 9.75 4.5 9.75Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.5L19.5 19.5C19.9142 19.5 20.25 19.1642 20.25 18.75L20.25 15C20.25 14.5858 19.9142 14.25 19.5 14.25L4.5 14.25C4.08579 14.25 3.75 14.5858 3.75 15L3.75 18.75C3.75 19.1642 4.08579 19.5 4.5 19.5Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnUnactive);
export default __webpack_public_path__ + "static/media/column-unactive.a019039af6cae6555c217c1d6a91264a.svg";
export { ForwardRef as ReactComponent };